import OUTDATED_BUILD_MESSAGE from './outdatedBuildMessage';
import { showRefreshToast } from './toastManager';

/*
 * TEMPORARY — remove a few days after Calendar Undo is live in production.
 *
 * Undo changed the Build programming endpoints to require a `batchId` (and to wrap
 * item payloads in `assignment`). A tab still running a pre-Undo build sends the old
 * payloads, and the API's request validation rejects them with these messages. When
 * that happens, the fix is to load the new build, so we offer a refresh instead of
 * leaving the user with a validation error they can't act on.
 */
const OUTDATED_BUILD_MESSAGES = [
  'should have required property \'assignment\'',
  'should have required property \'batchId\'',
];

export const isOutdatedBuildError = (err) => {
  const { config, response } = err || {};
  if (response?.status !== 400) return false;
  if (!/\/calendars\/programming/.test(config?.url || '')) return false;

  const validationMessages = (response.data?.error?.errors || []).map((error) => error.message);
  return [response.headers?.message, ...validationMessages]
    .some((message) => OUTDATED_BUILD_MESSAGES.includes(message));
};

/** Let a waiting service worker take over first so the reload can't land on the old build. */
const reloadToLatestBuild = () => {
  if (!('serviceWorker' in navigator)) {
    window.location.reload();
    return;
  }
  navigator.serviceWorker.getRegistration()
    .then((registration) => registration?.waiting?.postMessage({ type: 'SKIP_WAITING' }))
    .catch(() => {})
    .finally(() => window.location.reload());
};

export const outdatedBuildInterceptor = (err) => {
  if (isOutdatedBuildError(err)) {
    /** Call sites toast `headers.message`; showErrorToast skips this one so the refresh
     * toast below is the only one the user sees. */
    // eslint-disable-next-line no-param-reassign
    err.response.headers.message = OUTDATED_BUILD_MESSAGE;
    showRefreshToast(OUTDATED_BUILD_MESSAGE, reloadToLatestBuild);
  }
  return Promise.reject(err);
};
